import isApiError from "@insite/client-framework/Common/isApiError";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    getAlsoPurchasedProductsCollectionV2,
    GetProductCollectionApiV2Parameter,
    getProductCollectionV2,
    GetRelatedProductCollectionApiV2Parameter,
    getRelatedProductsCollectionV2,
} from "@insite/client-framework/Services/ProductServiceV2";
import { StorefrontAccess } from "@insite/client-framework/Services/SettingsService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Handler, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { RequestDataFromApi, chain,  } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";



type Parameter = (
    | GetProductCollectionApiV2Parameter
    | GetRelatedProductCollectionApiV2Parameter
    | GetAlsoPurchasedProductCollectionApiV2Parameter
) & { isLoadMore?: boolean } & HasOnSuccess<ProductModel[]> &
    HasOnError<string>;
type Props = {
    apiParameter:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const RequestDataFromApiWithProperties: HandlerType = async props => {
    const state = props.getState();
    const currentPage = getCurrentPage(state);
    const { storefrontAccess } = getSettingsCollection(state).productSettings;
    if (
        storefrontAccess === StorefrontAccess.SignInRequiredToBrowse &&
        !state.context.session.isAuthenticated &&
        (currentPage.fields.excludeFromSignInRequired || currentPage.type === "SignInPage")
    ) {
        return false;
    }

    try {
        if ("relationship" in props.apiParameter) {
            const apiParameter = {
            ...props.apiParameter,
            expand: [
                    ...new Set([
                    ...(props.apiParameter.expand ?? []),
                    "properties" as const
                    ])
                ]
            };
            props.apiResult = await getRelatedProductsCollectionV2(apiParameter);
        } else if ("productId" in props.apiParameter && props.apiParameter?.type === "alsoPurchased") {
            props.apiResult = await getAlsoPurchasedProductsCollectionV2(props.apiParameter);
        } else {
            const apiParameter = {
            ...props.apiParameter,
            expand: [
                    ...new Set([
                    ...(props.apiParameter.expand ?? []),
                    "properties" as const
                    ])
                ]
            };
            props.apiResult = await getProductCollectionV2(apiParameter);
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }

        if (storefrontAccess === StorefrontAccess.SignInRequiredToBrowse && error.status === 403) {
            // auth timed out with SignInRequiredToBrowsee - throw this up as a 401 so DisplayError reloads the site
            error.status = 401;
            error.errorJson = { message: "error" };
        }

        throw error;
    }
};

replaceInChain(chain, RequestDataFromApi, RequestDataFromApiWithProperties);